import { useEffect } from "react"
import { useForms } from "./useForm"

export function useSalesforce(recordtypeId) {

  const { fetchRecordTypeId, fetchSalesforce } = useForms()

  useEffect(() => {
    fetchSalesforce()
  }, [fetchSalesforce])

  useEffect(() => {
    fetchRecordTypeId(recordtypeId)
  }, [fetchRecordTypeId, recordtypeId])
}
